import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment-timezone';
import DateRangeModel from '../../components/dialBackInput/date-range-picker.model';

function LogiCommon() {}

LogiCommon.prototype.getParamsObject = function(params1) {

    var result = {};
    var paramComponents = params1.split(/&(?=[^&\|]+\|[^|]+)/);

    paramComponents.forEach(function(paramcomp) {

        var paramitems = paramcomp.split('|');

        result[paramitems[0]] = paramitems[1];
    });
    if (result.inpStartDate) {
        result.inpStartDate = result.inpStartDate.replace(/-/g, '/');
        result.inpStartDate = result.inpStartDate.substring(0, 10);
    }

    if (result.inpEndDate) {
        result.inpEndDate = result.inpEndDate.replace(/-/g, '/');
        result.inpEndDate = result.inpEndDate.substring(0, 10);
    }

    if (result.wherecondition) {
        let whereConditionObj = [];
        if (typeof result.wherecondition === 'string') {
          whereConditionObj = JSON.parse(result.wherecondition);
        }
        result.WhereCondition = whereConditionObj;
        delete result.wherecondition;
    }
    return result;
};

function appendCondition(queryGroups, lhs, operator, rhs, valueType, groupIndex, lhstitle, optitle, valuename, columnOptions) {
    var result = [];

    if (!groupIndex) {
        groupIndex = 0;
    }

    if (queryGroups && (queryGroups.length > 0)) {
        result = queryGroups;
    }
    else {
        result.push({ conditions: [] });
    }

    var group = result[groupIndex];
    var conditions = group.conditions;

    var condition = { selectedLhs: lhs, selectedOperator: operator, valueType: valueType, selectedConjunction: "AND" };

    if ((operator === 'in') || (operator === 'notin') || $.isArray(rhs)) {
        condition.selectedRhs = rhs;
        condition.listtype = true;
    }
    else {
        condition.rhsText = rhs;
        condition.listtype = false;
    }

    condition.lhstitle = lhstitle;
    condition.optitle = optitle;
    condition.valuename = valuename;


    if (columnOptions && (_.isEmpty(condition.desc) || _.startsWith(condition.desc, 'dim'))) {
        if (
            !_.startsWith(condition.selectedLhsTitle, 'dim') &&
            !_.isEmpty(condition.selectedLhsTitle) &&
            !_.isEmpty(condition.selectedOperator) &&
            !_.isEmpty(condition.rhsText)) {
            condition.desc = condition.selectedLhsTitle + " " + condition.selectedOperatorTitle + " " + condition.rhsText;
        } else if (!_.isEmpty(ko.unwrap(columnOptions))) {
            FixCondition(condition, ko.unwrap(columnOptions));
        }
    }


    conditions.push(condition);

    return result;
}

LogiCommon.prototype.removeTimePortion = function (dateTimeString) {

    var t = dateTimeString.toLowerCase().indexOf("t");

    if (t > 0) {
        return dateTimeString.substring(0, t);
    }

    return dateTimeString;
};

function inValuesToArray(values, valueType) {

    var result = values.replace(/^\(/, '').replace(/\)$/, '').replace(/\'/g, '').replace('+++','/').split(',');

    if (valueType === 'integer') {
        return result.map(Number);
    }

    return $.map(result, function (item) {
        return item.trim();
    });
}

function buildConditionGroupFromClause(groups, expression, valueType, lhstitle, columnOptions) {
    // split the expression into:  lhs op rhs (where op is one of these operators: =,!=,<,>,<=,>=,between,and,notin,in,notlike,like)
    var tokens = expression.split(/(!?=|<=?|>=?| between | and | notin | in | notlike | like )(.+)/);

    if (tokens.length > 2) {
        // token[0] = left-hand-side,  token[1] = operator, token[2] = right-hand-side
        var lhs = tokens[0].trim();
        var op = tokens[1].trim();
        var rhs = (op === 'in' || op === 'notin') ? inValuesToArray(tokens[2].trim(), valueType) : tokens[2].trim();
        groups = appendCondition(groups, lhs, op, rhs, valueType, undefined, lhstitle, undefined, undefined, columnOptions);
    }
    return groups;
}

function FixCondition(condition, columnOptions) {
    // var lhs = $.grep(columnOptions, function (co) { return co.name === condition.selectedLhs; });
    var conditionValue;

    condition.selectedLhsTitle = condition.lhstitle ? condition.lhstitle : condition.selectedLhs;

    // if (lhs.length > 0) {
    //     condition.selectedLhsTitle = lhs[0].title;
    // }
    if (condition.selectedOperator === 'in' || condition.selectedOperator === 'notin') {
        condition.selectedOperatorTitle = condition.selectedOperator === 'in' ? 'in' : 'not in';
        conditionValue = _.isArray(condition.selectedRhs) ? condition.selectedRhs.join(', ') : condition.selectedRhs;
    }
    else {
        conditionValue = condition.rhsText;
    }
    condition.selectedOperatorTitle = getOperatorDisplayText(condition.selectedOperator);
    condition.desc = condition.selectedLhsTitle + " " + condition.selectedOperatorTitle + " " + conditionValue;
}
const OPERATOR_DISPLAY_TEXT_MAP = {
    'in': 'in',
    'notin': 'not in',
    '=': 'equals',
    '>': 'is greater than',
    '>=': 'is greater than or equal to',
    '<': 'is less than',
    '<=': 'is less than or equal to'
};

function getOperatorDisplayText(operator) {
    var displayText = OPERATOR_DISPLAY_TEXT_MAP[operator];
    if (_.isUndefined(displayText)) {
        console.error('flexomniquery-widget::getOperatorDisplayText: Could not find operator "' + operator + '"');
        return '??';
    }
    return displayText;
}

LogiCommon.prototype.buildConditionGroupsFromExpression = function(groups, expression, valueType, lhstitle, columnOptions) {

    expression = expression.replace(/-ss-/g, '/');

    if (!valueType) {
        valueType = 'integer';
    }

    var explc = expression.toLowerCase();

    var indor = explc.indexOf('-or-');
    var indand = explc.indexOf('-and-');

    var hasOr = indor >= 0;

    var orval = (indor >= 0) ? expression.substring(indor, indor + 4) : '-or-';
    var andval = (indand >= 0) ? expression.substring(indand, indand + 5) : '-and-';

    var clauses = hasOr ? expression.split(orval) : expression.split(andval);
    // this is a giant hack that all passed in expressions will use the same value type
    // there are a few cases where we pass in more than one expression and thru luck it's working
    // var valueTypes = valueType.split('-');
    // var lhstitles = lhstitle ? lhstitle.split('-') : [];

    for (var i = 0; i < clauses.length; i++) {
        groups = buildConditionGroupFromClause(groups, clauses[i], valueType, lhstitle, columnOptions);
    }

    return groups;
};

LogiCommon.prototype.buildConditionGroupsFromJson = function (groups, jsonObj) {

    var keys = Object.keys(jsonObj);

    keys.forEach(function (key) {

        groups = appendCondition(groups, key, '=', jsonObj[key], 'string');
    });

    return groups;
};

LogiCommon.prototype.GetPropertiesToSave = function(webexSiteObs, hierarchyObs, daterangeObs, dataFilterObs) {

    var result = {};

    if (webexSiteObs && webexSiteObs() && webexSiteObs().id) {
        result.selectedWebexSite = webexSiteObs().id;
    } else {
        result.selectedWebexSite = -1;
    }

    if (hierarchyObs && hierarchyObs()) {
        result.selectedHierarchyValues = hierarchyObs();
    }

    if (daterangeObs && daterangeObs()) {
        result.selectedDateRangeValues = daterangeObs();
    }

    if (dataFilterObs && dataFilterObs()) {
        result.selectedDataFilter = dataFilterObs();
    }

    return result;
};

function getConditionValue(groups, lhs) {

    var result = null;

    if ((groups.length > 0) && (groups[0].conditions)) {

        for (var i = 0; i < groups[0].conditions.length; i++) {

            if (groups[0].conditions[i].selectedLhs === lhs) {

                result = ((groups[0].conditions[i].selectedOperator === 'in') || (groups[0].conditions[i].selectedOperator === 'notin')) ? groups[0].conditions[i].selectedRhs : groups[0].conditions[i].rhsText;

                break;
            }

        }
    }

    return result;
}

LogiCommon.prototype.GetHistoricalViewLevelOptions = function(dateRangeModel, urlparamobject, hierarchy, dataFilter) {

    let daterange = dateRangeModel.getCurrentRange();
    var duration = moment.duration(daterange.endDate.diff(daterange.startDate));
    var diffDays = Math.ceil(duration.asDays());

    var result = {
        inpStartDate: daterange.startDate.format("YYYY/MM/DD"),
        inpEndDate: daterange.endDate.format("YYYY/MM/DD"),
        inpDayNumber: diffDays,
        inpHierarchyName: (hierarchy && hierarchy.hierarchyId) ? hierarchy.hierarchyId : -1,
        inpHierarchyLevel: (hierarchy && hierarchy.levelNbr) ? hierarchy.levelNbr : "1",
        inpHierarchyPath: hierarchy ? hierarchy.paths : "",
        BridgeWhereCondition: "1=1",
        EndpointWhereCondition: "1=1",
        inpEndpointSID: "-1",
        inpHierarchyLevelCaption: "",
        inpHierachyNameCaption: "None",
        inpSearchEndpoint: "",
        inpSearchEndpoint1: "",
        inpSearchIssueEndpoint: "",
        inpSelectCallStatus: "Connected,Not Connected,SIP Toll Attack",
        inpSelectQualityBand: "0,1,2,3",
        InventoryWhereCondition: "1=1",
        InventoryWhereCondition2: "1=1",
        IssueWhereCondition: "1=1",
        MeetingWhereCondition: "1=1",
        UnmanagedWhereCondition: "1=1",
        EndpointStatus: "",
        inpSearchEndpointSQL1: "",
        inpSearchIssueEndpointSQL1: "",
        inpSideNav: "",
        rdReportFormat: "",
        tabEndpoint: "tabDetails",
        tabIssues: "",
        inpSearchMeeting: "",
        WhereCondition: dataFilter ? dataFilter : "1=1",
        rdShowWait: "True",
        rdWaitStyle: "_Themes/vyopta/Theme.css"
    };

    result.hierarchyName = (hierarchy && hierarchy.hierarchyName) ? hierarchy.hierarchyName : "";
    result.hierarchyPath = (hierarchy && hierarchy.paths) ? hierarchy.paths : "";

    $.extend(true, result, urlparamobject);

    return result;
};

function FixAliases(dataFilter, aliasmapping) {
    if (aliasmapping &&
        (!$.isEmptyObject(aliasmapping)) &&
        dataFilter &&
        $.isArray(dataFilter) &&
        (dataFilter.length > 0)) {

        var newfilter = $.extend(true, [], dataFilter);

        for (var i = 0; i < newfilter.length; i++) {

            var group = newfilter[i];

            if (group.conditions && (group.conditions.length > 0)) {

                for (var j = 0; j < group.conditions.length; j++) {

                    var condition = group.conditions[j];

                    var sellhs = condition.selectedLhs.toLowerCase();

                    if (aliasmapping[sellhs]) {
                        condition.selectedLhs = aliasmapping[sellhs];
                    }
                }
            }
        }
        return newfilter;
    } else {
        return dataFilter;
    }
}

// TODO: This needs a better name than GetHistoricalViewLevelOptions2. How is this different than GetHistoricalViewLevelOptions?
LogiCommon.prototype.GetHistoricalViewLevelOptions2 = function (hierarchy, dateRangeModel, urlparamobject, dataFilter, daysPerWeek, hoursPerDay, aliasmapping) {
    if (dataFilter === "1=1") {
        dataFilter = null;
    }
    var result = {};
    $.extend(true, result, urlparamobject);

    result.WhereCondition = (dataFilter) ? JSON.stringify(dataFilter.WhereConditionObj) : '[]';
    result.WhereConditionObj = dataFilter;
    result.WhereConditionConjunction = (dataFilter) ? dataFilter.WhereConditionConjunction : 'AND';

    if (dateRangeModel) {
        let daterange = dateRangeModel
        if (dateRangeModel instanceof DateRangeModel) {
            daterange = dateRangeModel.getCurrentRange();
        }

        result.inpStartDate = daterange.startDate.format("YYYY/MM/DD");
        result.inpEndDate = daterange.endDate.format("YYYY/MM/DD");
        if (result.inpstartdate) {
            delete result.inpstartdate;
        }
        if (result.inpenddate) {
            delete result.inpenddate;
        }
    }

    var mainFilter = [];

    result.hierarchyName = (hierarchy && hierarchy.hierarchyName) ? hierarchy.hierarchyName : "";
    result.hierarchyPath = (hierarchy && hierarchy.paths) ? hierarchy.paths : "";

    if (hierarchy && (hierarchy.hierarchyId !== -1)) {

        mainFilter = appendCondition(mainFilter, 'hierarchyID', '=', hierarchy.hierarchyId, 'numeric', null, 'Hierarchy', 'is', [result.hierarchyName]);
        mainFilter = appendCondition(mainFilter, 'hierarchyPath', '=', hierarchy.paths);
    }

    result.mainFilter = (mainFilter && (mainFilter.length > 0)) ? ko.toJSON(mainFilter) : "";

    if (daysPerWeek) {
        result.daysPerWeek = daysPerWeek;
    }

    if (hoursPerDay) {
        result.hoursPerDay = hoursPerDay;
    }

    return result;
};

export default LogiCommon;
